import { apiFetch } from "./client.js";
import type { WhatsappSession } from "../types.ts";

/**
 * Multi-account helpers (Baileys + Unipile WhatsApp/Instagram/...).
 * Backend endpoints live under /whatsapp/accounts.
 */

export type AccountListResponse = { accounts: WhatsappSession[] };

export async function listAccounts(): Promise<WhatsappSession[]> {
  const data = (await apiFetch("/whatsapp/accounts")) as AccountListResponse | null;
  return data?.accounts || [];
}

export async function linkUnipileExisting(
  accountId: string,
  options: { label?: string; setDefault?: boolean } = {},
): Promise<{ ok: boolean; accountId: string; accountType: string; label: string }> {
  return apiFetch("/whatsapp/accounts/link-unipile-existing", {
    method: "POST",
    body: JSON.stringify({
      account_id: accountId,
      label: options.label ?? "",
      set_default: options.setDefault ?? false,
    }),
  }) as Promise<{ ok: boolean; accountId: string; accountType: string; label: string }>;
}

export async function startUnipileHostedAuth(): Promise<{ url: string }> {
  return apiFetch("/whatsapp/accounts/link-unipile-hosted", {
    method: "POST",
  }) as Promise<{ url: string }>;
}

export async function deleteAccount(sessionId: string): Promise<void> {
  await apiFetch(`/whatsapp/accounts/${encodeURIComponent(sessionId)}`, { method: "DELETE" });
}

/** Reconecta uma conta existente (status=qr/disconnected). Retorna a URL Hosted
 * Auth da Unipile pra ser aberta em nova aba — usuário escaneia QR ali, Unipile
 * dispara webhook hosted-callback e o status volta pra 'connected' preservando
 * histórico e attendees. */
export async function reconnectAccount(sessionId: string): Promise<{ url: string; sessionId: string }> {
  return apiFetch(`/whatsapp/accounts/${encodeURIComponent(sessionId)}/reconnect`, {
    method: "POST",
  }) as Promise<{ url: string; sessionId: string }>;
}

export type AccountPatch = { label?: string; isDefault?: boolean };

export async function patchAccount(
  sessionId: string,
  patch: AccountPatch,
): Promise<{ sessionId: string; label: string; isDefault: boolean }> {
  return apiFetch(`/whatsapp/accounts/${encodeURIComponent(sessionId)}`, {
    method: "PATCH",
    body: JSON.stringify(patch),
  }) as Promise<{ sessionId: string; label: string; isDefault: boolean }>;
}
